/**
 * Global application configuration.
 * Toggle feature flags here to show/hide UI elements.
 */
const appConfig = {
  /**
   * Show the Demo Credentials card on the Login screen.
   * Set to false to hide it in production.
   */
  showDemoCredentials: true,

  /**
   * Multiple company mode.
   * false → show the standard Login screen for unauthenticated users.
   * true  → show the Company selection page first; the entered value is
   *          sent to /company and the app redirects to result.url.
   */
  multiple: false,

  /**
   * Show the notifications bell icon in the top header.
   * Set to false to hide it.
   */
  headerNotifications: false,
};

export default appConfig;
